module.exports = __webpack_public_path__ + "img/reserve-bailey.28f0f81d.png";